module.exports = __webpack_public_path__ + "static/recruit__team__leader1-a70b0879778923a95d6d77de85ea22a9.jpg";